export default __webpack_public_path__ + "static/media/crevette.1cae4aa1.webp";